// Fusion Glass brand logo (owner-supplied artwork in /public).
// The mark is the arc + three blue glass panels; the wordmark is rendered as text so it
// stays crisp and can switch colour on dark backgrounds.
export const LogoMark = ({ className = "h-9", light = false }) => (
  <img
    src={light ? "/logo-mark-dark.png" : "/logo-mark.png"}
    alt=""
    aria-hidden="true"
    className={`${className} w-auto select-none`}
    draggable="false"
  />
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3" data-testid="nav-logo">
    <LogoMark className="h-10 sm:h-12" light={light} />
    <span className={`font-display text-[17px] leading-none tracking-[0.18em] sm:text-lg ${light ? "text-white" : "text-slate-900"}`}>
      <span className="font-light">FUSION</span>
      <span className="font-bold">GLASS</span>
    </span>
  </span>
);

export default Logo;
